import { Reference } from '@approvalmax/types';
import { DropdownEditor, Field } from '@approvalmax/ui';
import { domain } from 'modules/data';
import { PlainDataProvider } from 'modules/data-providers';
import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

import RequestFormRow from '../../../../../components/RequestFormRow/RequestFormRow';
import RequestFormRowGroup from '../../../../../components/RequestFormRowGroup/RequestFormRowGroup';
import RequestFormSection from '../../../../../components/RequestFormSection/RequestFormSection';
import { useQBOVendorRequestContext } from '../../QBOVendorRequestContext';
import { messages } from './FinanceSection.messages';

const qa = bemFactory.qa('reqf-qbooks-vendor-request__finance');

interface FinanceSectionProps {
    className?: string;
    accounts: domain.QBooksAccount[];
    currencies: Reference[];
}

const FinanceSection: FC<FinanceSectionProps> = (props) => {
    const { currencies } = props;

    const { changeVendorProperty, vendor } = useQBOVendorRequestContext();

    return (
        <RequestFormSection header={messages.header}>
            <RequestFormRowGroup>
                <RequestFormRow>
                    <Field title={messages.defaultCurrency}>
                        <PlainDataProvider items={currencies}>
                            <DropdownEditor
                                qa={qa('select-currency')}
                                placeholder={messages.dropdownCurrencyPlaceholder}
                                value={vendor.currencyCode || null}
                                onChange={changeVendorProperty('currencyCode')}
                            />
                        </PlainDataProvider>
                    </Field>
                </RequestFormRow>
            </RequestFormRowGroup>
        </RequestFormSection>
    );
};

export default memo(FinanceSection);
